import request from '../utils/request';
import type { 
  Product,
  ProductCreateParams,
  ListParams,
  ListResponse
} from '../types/product';

export function getProductList(params: ListParams) {
  return request.get<ListResponse>('/api/v1/products/', { params });
}

export function getProductDetail(id: number) {
  return request.get<Product>(`/api/v1/products/${id}/`);
}

export function createProduct(data: ProductCreateParams) {
  return request.post<Product>('/api/v1/products/', data);
}

export function updateProduct(id: number, data: Partial<Product>) {
  return request.put<Product>(`/api/v1/products/${id}/`, data);
}

export function deleteProduct(id: number) {
  return request.delete<void>(`/api/v1/products/${id}/`);
}

// 分拣条码相关API
export function createSortingCode(data: { code: string; description?: string }) {
  return request.post<any>('/api/v1/products/sorting-codes/', data);
}

export function getSortingCodeList(params?: ListParams) {
  return request.get<any>('/api/v1/products/sorting-codes/', { params });
} 